import script from "./Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Video.vue?vue&type=script&setup=true&lang=js"

import "./Video.vue?vue&type=style&index=0&id=1e6c2f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6c2f34"]])

export default __exports__